import type { App } from "vue";
import type { AxiosResponse } from "axios";
import axios from "axios";
import VueAxios from "vue-axios";
import JwtService from "@/services/JwtService";
import { User } from "./auth";

/**
 * @description service to call HTTP request via Axios
 */
class ApiService {
  /**
   * @description property to share vue instance
   */
  public static vueInstance: App;

  /**
   * @description initialize vue axios
   */
  public static init(app: App<Element>) {
    ApiService.vueInstance = app;
    ApiService.vueInstance.use(VueAxios, axios);
    // ** const httpsAgent = new https.Agent({
    //  rejectUnauthorized: false,
    // });
    // ApiService.vueInstance.axios.defaults.httpsAgent = httpsAgent;
    ApiService.vueInstance.axios.defaults.baseURL = "https://api.agridev-vie.org/api";
    // ApiService.vueInstance.axios.defaults.baseURL ='https://back.romastechnologie.com/api';
    ApiService.vueInstance.axios.defaults.headers.common["Accept"] =
      "application/json";
    ApiService.vueInstance.axios.defaults.headers.common["Content-Type"] =
      "application/json";
    ApiService.vueInstance.use(VueAxios, axios);
  }

  /**
   * @description set the default HTTP request headers
   */
  public static setHeader(): void {
    ApiService.vueInstance.axios.defaults.headers.common[
      "Authorization"
    ] = `bearer ${JwtService.getToken()}`;
    ApiService.vueInstance.axios.defaults.headers.common["Accept"] =
      "application/json";

  }

  /**
   * @description send the GET HTTP request
   * @param resource: string
   * @param params: AxiosRequestConfig
   * @returns Promise<AxiosResponse>
   */
  public static query(resource: string, params: any): Promise<AxiosResponse> {
    return ApiService.vueInstance.axios.get(resource, params);
  }

  /**
   * @description send the GET HTTP request
   * @param resource: string
   * @param slug: string
   * @returns Promise<AxiosResponse>
   */
  public static get(
    resource: string,
    slug = "" as string
  ): Promise<AxiosResponse> {
    return ApiService.vueInstance.axios.get(`${resource}/${slug}`);
  }

  /**
   * @description set the POST HTTP request
   * @param resource: string
   * @param params: AxiosRequestConfig
   * @returns Promise<AxiosResponse>
   */

  // public static post(resource: string, params: any): Promise<AxiosResponse> {
  //   return ApiService.vueInstance.axios.post(`${resource}`, params);
  // }

  public static post(resource: string, params: any, config?: any): Promise<AxiosResponse> {
    return ApiService.vueInstance.axios.post(`${resource}`, params, config);
  }


  public static postWithFile(resource: string, params: any): Promise<AxiosResponse> {
    console.log("=== ApiService.postWithFile ===");
    console.log("Resource:", resource);
    console.log("Params type:", typeof params);
    console.log("Is FormData:", params instanceof FormData);
    
    if (params instanceof FormData) {
      console.log("FormData contents in ApiService:");
      for (const [key, value] of params.entries()) {
        console.log(`  ${key}:`, value);
      }
    }
    
    const token = JwtService.getToken();
    console.log("Token utilisé:", token ? "✅ Token présent" : "❌ Pas de token");
    
    return ApiService.vueInstance.axios.post(`${resource}`, params, {
      headers: {
        "Content-Type": "multipart/form-data",
        "Accept": "*/*"
      }
    });
  }

  public static putWithFile(resource: string, params: any): Promise<AxiosResponse> {
  console.log("=== ApiService.putWithFile ===");
  console.log("Resource:", resource);
  console.log("Params type:", typeof params);
  console.log("Is FormData:", params instanceof FormData);
  
  if (params instanceof FormData) {
    console.log("FormData contents in ApiService:");
    for (const [key, value] of params.entries()) {
      console.log(`  ${key}:`, value);
    }
  }
  
  const token = JwtService.getToken();
  console.log("Token utilisé:", token ? "✅ Token présent" : "❌ Pas de token");
  
  return ApiService.vueInstance.axios.put(`${resource}`, params, {
    headers: {
      "Content-Type": "multipart/form-data",
      "Accept": "*/*"
    }
  });
}

  /**
   * @description send the UPDATE HTTP request
   * @param resource: string
   * @param slug: string
   * @param params: AxiosRequestConfig
   * @returns Promise<AxiosResponse>
   */
  public static update(
    resource: string,
    slug: string,
    params: any
  ): Promise<AxiosResponse> {
    return ApiService.vueInstance.axios.put(`${resource}/${slug}`, params);
  }

  /**
   * @description Send the PUT HTTP request
   * @param resource: string
   * @param params: AxiosRequestConfig
   * @returns Promise<AxiosResponse>
   */
  // public static put(resource: string, params: any): Promise<AxiosResponse> {
  //   return ApiService.vueInstance.axios.put(`${resource}`, params);
  // }
  public static put(resource: string, params: any, config?: any): Promise<AxiosResponse> {
  return ApiService.vueInstance.axios.put(`${resource}`, params, config);
}


  /**
   * @description Send the DELETE HTTP request
   * @param resource: string
   * @returns Promise<AxiosResponse>
   */
  public static delete(resource: string): Promise<AxiosResponse> {
    return ApiService.vueInstance.axios.delete(resource);
  }
}

export default ApiService;

